import React from "react";
import { threeMReportApis } from "../../../../api/ThreeMReport";
import MonthlyScheduleDrawer from "../shared/MonthlyScheduleDrawer";
import { MachinerySummaryRow, headTagColor } from "./machineryShared";

// Per-machinery-item monthly schedule. Identity is composite — NORM rows key
// on machineryNormId, TOOLS rows on (toolId, workUomId) where an ABSENT id
// means IS NULL server-side (keeping the "Unlinked tool" row drillable), and
// EQUIPMENT rows on deploymentNormId. Consumables are excluded (as in the
// register), so the drawer's coverage ties out to the register row rather
// than to the larger Monthly P&L figure.

const MachineryMonthlyScheduleDrawer: React.FC<{
  open: boolean;
  projectId?: number | string;
  row?: MachinerySummaryRow | null;
  phaseId?: number | string;
  activityId?: number | string;
  onClose: () => void;
  getContainer?: () => HTMLElement;
}> = ({ open, projectId, row, phaseId, activityId, onClose, getContainer }) => {
  // Pass the row's source through untouched (defaulting only when absent) —
  // coercing EQUIPMENT to NORM would drill the wrong arm.
  const source = row?.source || "NORM";
  return (
    <MonthlyScheduleDrawer
      open={open}
      itemName={row?.itemName}
      itemCode={row?.itemCode}
      headLabel={row?.head}
      headColor={headTagColor(row?.head)}
      uomName={row?.uomName}
      entityLabel="machinery item"
      fetchKey={
        projectId && row
          ? [
              projectId,
              source,
              row.machineryNormId ?? "",
              row.toolId ?? "",
              row.workUomId ?? "",
              row.deploymentNormId ?? "",
              phaseId ?? "",
              activityId ?? "",
            ].join("|")
          : ""
      }
      fetchSchedule={() =>
        threeMReportApis.get3MMachineryMonthlySchedule(projectId as number, {
          source,
          machineryNormId: row?.machineryNormId,
          toolId: row?.toolId,
          workUomId: row?.workUomId,
          deploymentNormId: row?.deploymentNormId,
          phaseId,
          activityId,
        })
      }
      onClose={onClose}
      getContainer={getContainer}
    />
  );
};

export default MachineryMonthlyScheduleDrawer;
